// removed by extract-text-webpack-plugin
module.exports = {"popover":"app-3XFKZhWA","noticeButton":"app-2aLC9kXb","icon":"app-3R97LbnJ","tabs":"app-3GRWvf0a"};


//////////////////
// WEBPACK FOOTER
// ./src/wbap-components/noticeIcon/index.less
// module id = 681
// module chunks = 0